document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const toggleBtn = document.querySelector('.header__mobile-toggle');
  const mobileMenu = document.querySelector('.header__mobile-menu');
  const backdrop = document.querySelector('.header__mobile-backdrop');
  const drawerClose = document.querySelector('.header__drawer-close');

  if (!toggleBtn || !mobileMenu) return;

  // Scroll logic
  window.addEventListener('scroll', () => {
    if (window.scrollY > 30) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
  });

  function openMenu() {
    mobileMenu.classList.add('header__mobile-menu--open');
    if (backdrop) backdrop.classList.add('header__mobile-backdrop--open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('header__mobile-menu--open');
    if (backdrop) backdrop.classList.remove('header__mobile-backdrop--open');
    document.body.style.overflow = '';
  }

  // Hamburger opens drawer
  toggleBtn.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.contains('header__mobile-menu--open');
    isOpen ? closeMenu() : openMenu();
  });

  // Close via drawer X button
  if (drawerClose) {
    drawerClose.addEventListener('click', closeMenu);
  }

  // Close via backdrop tap
  if (backdrop) {
    backdrop.addEventListener('click', closeMenu);
  }

  // Close on link click
  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu);
  });
});